import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'
import { Card, CardTitle, CardSubtitle, CardContent } from '../components/Card.tsx'
import { InputOTP } from '../components/InputOTP.tsx'

export interface OTPCardProps {
  phone: string
  value: string
  onChange: (value: string) => void
  onComplete: (code: string) => void
  onResend: () => void
  onBack: () => void
  status?: 'default' | 'error' | 'verifying' | 'expired'
  className?: string
}

function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
  if (local.length === 10) {
    return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`
  }
  return phone
}

export const OTPCard = forwardRef<HTMLDivElement, OTPCardProps>(
  ({ phone, value, onChange, onComplete, onResend, onBack, status, className }, ref) => {
    return (
      <Card ref={ref} className={cn(className)}>
        <div className="otp-card-title-row">
          <button
            type="button"
            className="otp-card-back"
            aria-label="Go back"
            onClick={onBack}
          >
            &#8592;
          </button>
          <CardTitle>Verify your number</CardTitle>
        </div>
        <CardSubtitle>We sent a code to {formatPhone(phone)}</CardSubtitle>
        <CardContent>
          <InputOTP
            value={value}
            onChange={onChange}
            status={status}
            onComplete={onComplete}
            onResend={onResend}
          />
        </CardContent>
      </Card>
    )
  },
)

OTPCard.displayName = 'OTPCard'
